import Template from "@/src/components/templates/Roles/RolesOverviewTemplate";

const RolesOverview = () => <Template />;

export default RolesOverview;
